/**
 * Return an estimate of the carbon emissions produced by a page view.
 * @link https://developers.thegreenwebfoundation.org/co2js/overview/
 */

import { co2, hosting, averageIntensity } from '@tgwf/co2';

(() => {

  window.addEventListener('load', () => {

    /**
     * Check whether the current domain is served from a green web host.
     * https://developers.thegreenwebfoundation.org/co2js/tutorials/check-hosting/
     */

    const domain = window.location.hostname;
    hosting.check(domain).then((result) => {

      const isGreenHost = result;
      const emissions = new co2();

      /**
       * 1. Get average grid intensity data for all countries.
       * 2. Set the country in which the hosting server is located.
       * 3. Use average grid intensity data for the origin country.
       */

      const { data } = averageIntensity; /* 1 */
      const origin = data.BEL; /* 2 */
      const options = {
        gridIntensity: {
          dataCenter: origin /* 3 */
        }
      };

      /**
       * Iterate the list of resources and calculate the total number of
       * transferred bytes.
       */

      const resources = performance.getEntriesByType('resource');

      let transferredBytes = 0;
      resources.forEach((entry) => {
        transferredBytes = parseInt(transferredBytes + entry.transferSize);
      });

      /**
       * Estimate carbon emissions for the current page view and log the data
       * in the console.
       */

      const estimate = emissions.perVisitTrace(transferredBytes, isGreenHost, options);
      const grams = estimate.co2.toFixed(3);
      const notice = `This page visit emitted an estimated ${grams} grams of CO2. ${transferredBytes} bytes were transferred.`;

      console.log(notice);
    });
  });
})();
